


function add_note_to(object, object_id) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/notes/create/' + [object, object_id].join('/'),
        onOpen: function (elm, popup) {
            elm.find('form').ajaxFormSubmit(function(data){
                reload_location_if_needed(true);
            }.bind([elm,popup]), function(xhr, status, error) {
                console.log(xhr,status,error);
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het printen.", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function view_notes_of(object, object_id) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/notes/view/' + [object, object_id].join('/'),
        onOpen: function (elm, popup) {

        }
    });
    return false;
}